import { INITIAL_FORM_MANDATORY, TIPE_PEMBAYARAN_NON_TUNAI_OPTIONS } from "../constant";

const initialPersonalData = {
  name: null,
  nik: null,
  hpNumber1: null,
  hpNumber2: null,
  email: null,
  address: null,
  kkNumber: null,
  npwp: null,
  province: null,
  kabkot: null,
  kecamatan: null,
  kelurahan: null,
  zipCode: null,
  gender: null,
  job1: null,
  job2: null,
  religion: null,
  memberId: null,
  memberLevel: null,
  loyaltyLevel: null,
  facebook: null,
  instagram: null,
  linkedin: null,
  x: null,
  tiktok: null,
  hobby: null,
  interest: null,
};

const personalDataFormGroup = {
  nama: INITIAL_FORM_MANDATORY,
  nik: { value: null },
  noHp1: INITIAL_FORM_MANDATORY,
  noHp2: { value: null },
  email: INITIAL_FORM_MANDATORY,
  alamat: INITIAL_FORM_MANDATORY,
  kkNumber: { value: null },
  npwp: { value: null },
  provinsi: INITIAL_FORM_MANDATORY,
  kota: INITIAL_FORM_MANDATORY,
  kecamatan: INITIAL_FORM_MANDATORY,
  kelurahan: INITIAL_FORM_MANDATORY,
  kodePos: { value: null },
  jenisKelamin: INITIAL_FORM_MANDATORY,
  pekerjaan1: INITIAL_FORM_MANDATORY,
  pekerjaan2: { value: null },
  agama: INITIAL_FORM_MANDATORY,
  memberId: { value: null },
  memberLevel: { value: null },
  loyaltyLvl: { value: null },
  facebook: { value: null },
  instagram: { value: null },
  linkedIn: { value: null },
  x: { value: null },
  tiktok: { value: null },
  hobby: { value: null },
  interest: { value: null },
};

export const formGroup = {
  kodeCabang: INITIAL_FORM_MANDATORY,
  noFakturJualBengkel: { value: null },
  tanggalFakturJualBengkel: { value: null },
  kategoriFakturJualBengkel: { value: null },
  noHotline: { value: null },
  noBooking: { value: null },
  noProspect: { value: null },
  mekanikSebelumnya: {value: null},
  tipeFakturJualBengkel: INITIAL_FORM_MANDATORY,
  claimNo: { value: null },
  fjbSource: { value: null },
  jenisProspect: { value: null },
  dataUnit: {
    noPolisi: INITIAL_FORM_MANDATORY,
    noRangka: INITIAL_FORM_MANDATORY,
    noMesin: INITIAL_FORM_MANDATORY,
    kodeVariant: INITIAL_FORM_MANDATORY,
    namaVariant: INITIAL_FORM_MANDATORY,
    tahunMotor: { value: null },
    informasiBensin: { value: null },
    kmTerakhir: INITIAL_FORM_MANDATORY,
  },
  dataPemilik: {
    isCompany: { value: null },
    ...personalDataFormGroup,
  },
  dataPembawa: {
    isBuyer: { value: null },
    ...personalDataFormGroup,
  },
  dataAnalisa: {
    rekomendasiSa: INITIAL_FORM_MANDATORY,
    keluhanKonsumen: INITIAL_FORM_MANDATORY,
  },
  dataTransaksi: {
    locator: { value: null },
    paket: INITIAL_FORM_MANDATORY,
    tipePromo: {value: null},
    promoId: {value: null},
    namaPromo: {value: null},
    kodeVoucher: {value: null},
    tipePembayaran: {value: null},
    tipePembayaranNonTunai: {value: null},
    kodeBank: {value: null},

    totalJasaSebelumDiskon: {value: null},
    totalJasaSesudahDiskon: {value: null},
    totalJasaDiskon: {value: null},
    totalEstimasiWaktu: {value: null},

    totalPartSebelumDiskon: {value: null},
    totalPartSesudahDiskon: {value: null},
    totalPartDiskon: {value: null},
    totalTitipanHotlin: {value: null},
    totalKelebihanKekurangan: {value: null},

    dataJob: { value: null },
    dataPartQR: { value: null },
    dataPartNonQR: { value: null },
  },
  dataTambahan: {
    noWorkOrder: INITIAL_FORM_MANDATORY,
    tanggalService: INITIAL_FORM_MANDATORY,
    waktuPKB: { value: null },
    asalUnitEntry: INITIAL_FORM_MANDATORY,
    mekanik: INITIAL_FORM_MANDATORY,
    finalCheck: INITIAL_FORM_MANDATORY,
    jenisPit: INITIAL_FORM_MANDATORY,
    waktuPendaftaran: { value: null },
    waktuSelesai: { value: null },
    totalFrt: { value: null },
    sa: INITIAL_FORM_MANDATORY,
    adminFjb: { value: null },
  },
  dataKeterangan: {
    keterangan: { value: null },
  },
};

export const initialDataUnit = {
  noPolisi: null,
  noRangka: null,
  noMesin: null,
  kodeVarian: null,
  namaVarian: null,
  tahunMotor: null,
  informasiBensin: null,
  kmTerakhir: null,
};

export const initialDataPemilik = {
  isCompany: null,
  ...initialPersonalData,
};

export const initialDataPembawa = {
  isBuyer: null,
  ...initialPersonalData,
};

export const initialDataAnalisa = {
  rekomendasiSa: null,
  keluhanKonsumen: null,
};

export const initialDataTransaksi = {
    locator: null,
    paket: null,
    tipePromo: null,
    promoId: null,
    namaPromo: null,
    kodeVoucher: null,
    tipePembayaran: "TUNAI",
    tipePembayaranNonTunai: null,
    kodeBank: null,

    totalJasaSebelumDiskon: 0,
    totalJasaSesudahDiskon: 0,
    totalJasaDiskon: 0,
    totalEstimasiWaktu: 0,

    totalPartSebelumDiskon: 0,
    totalPartSesudahDiskon: 0,
    totalPartDiskon: 0,
    totalTitipanHotlin: 0,
    totalKelebihanKekurangan: 0,

    dataJob: null,
    dataPartQR: null,
    dataPartNonQR: null,
  };

export const initialDataTambahan = {
  noWorkOrder: null,
  tanggalService: null,
  waktuPKB: null,
  asalUnitEntry: null,
  namaMekanik: null,
  finalCheck: null,
  jenisPit: null,
  waktuPendaftaran: null,
  waktuSelesai: null,
  totalFrt: null,
  sa: null,
  adminFjb: null,
};

export const initialDataKeterangan = {
  keterangan: null,
};
